<script setup>
// ============================================================================
// BonBoZ: trang Thống kê > TRANG — dựng lại theo đúng bố cục Pancake.
//
// BỐ CỤC, từ trên xuống, đúng thứ tự Pancake:
//   1. Tổng quan về trang  — hai đường: Số bình luận · Số tin nhắn
//   2. Bốn ô nổi bật       — SĐT mới · KH cũ TT qua tin nhắn · Khách mới ·
//                            H.thoại tin nhắn mới, kèm % so kỳ trước
//   3. Thống kê chi tiết   — bảng 16 cột, tab [Theo ngày] [Theo giờ] [Tuỳ chỉnh]
//
// ĐÃ GỠ so với bản trước, vì Pancake để chúng ở trang khác chứ không phải mất
// thông tin: biểu đồ so sánh giữa các trang, khối "Phụ trách & tag phân loại"
// (nay ở trang Nhân viên và trang Thẻ hội thoại), và ô "Tỷ lệ ra số" (nay là
// cột "SĐT mới / KH mới" trong bảng).
//
// GIỮ LẠI SO VỚI PANCAKE, vì người dùng đã yêu cầu riêng trước đó: dải chọn
// khoảng ngày, `PhamVi` (đang xem những trang nào), và HÀNG TAB TRANG. Hàng tab
// chính là thứ Pancake đặt ở thanh điều hướng trên cùng ("Tuyển Dụng - Bon…"),
// chỉ khác chỗ đứng — nên giữ nó là giữ đúng chức năng của Pancake.
//
// TAB TRANG điều khiển TOÀN BỘ phần dưới nó: biểu đồ, ô nổi bật, bảng. Một công
// tắc phạm vi cho cả thân trang — bấm ở dưới mà đổi ở trên là thứ không ai đoán
// được, nên công tắc phải đứng trước mọi thứ nó đổi.
//
// SO VỚI KỲ TRƯỚC: gọi API lần thứ hai với đúng khoảng ngày liền trước, cùng
// độ dài. Con số phần trăm luôn đi kèm ĐÚNG KHOẢNG NGÀY nó đem ra so — bản cũ
// chỉ hiện "▲12%" mà không nói so với cái gì, nên không kiểm lại được.
// ============================================================================
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import HieuSuatAPI from 'dashboard/api/bonboz/hieuSuat';
import { useAlert } from 'dashboard/composables';
import { useSelectedPages } from 'dashboard/composables/useSelectedPages';
import { ngay } from 'dashboard/helper/dinhDangNgay';
import { kyTruoc } from 'dashboard/helper/tongQuan';
import BieuDoTrang from './BieuDoTrang.vue';
import BangTheoNgay from './BangTheoNgay.vue';
import SectionCard from './SectionCard.vue';
import ReportHeader from '../components/ReportHeader.vue';
import OverviewReportFilters from '../components/OverviewReportFilters.vue';
import PhamVi from './PhamVi.vue';

const { t } = useI18n();
// Moi con so tren trang nay chi duoc dem tren nhung trang dang chon o bang
// dieu khien.
const { selectedInboxIds } = useSelectedPages();

const dangTai = ref(true);
const dangTaiBang = ref(false);
const khoang = ref(null);
const moc = ref(null); // khoảng ngày của kỳ trước, để ghi rõ đang so với gì
const cacTrang = ref([]); // tên trang cho hàng tab

// Số theo NGÀY luôn được tải: biểu đồ và bốn ô nổi bật đọc từ đây, kể cả khi
// bảng đang ở tab Theo giờ.
const theoNgay = ref(null);
const theoNgayTruoc = ref(null);
// Số theo GIỜ chỉ tải khi người dùng bấm sang tab đó — 24 dòng nữa cho một tab
// phần lớn thời gian không ai mở.
const theoGio = ref(null);

const gom = ref('ngay');
const trangCua = ref(null); // null = tổng các trang

// Tab trang thu hẹp phạm vi; không chọn thì dùng đúng lựa chọn ở Bảng điều khiển.
const phamVi = computed(() =>
  trangCua.value === null ? selectedInboxIds.value : [trangCua.value]
);

const goiNgay = (tu, den, kieu) =>
  HieuSuatAPI.theoNgay({
    since: tu,
    until: den,
    inboxIds: phamVi.value,
    gom: kieu,
  }).then(r => r.data);

const taiGio = async () => {
  if (theoGio.value || !khoang.value) return;
  dangTaiBang.value = true;
  try {
    theoGio.value = await goiNgay(khoang.value.from, khoang.value.to, 'gio');
  } catch {
    theoGio.value = null;
    gom.value = 'ngay';
    useAlert(t('BONBOZ.TRANG_TK.LOI_TAI'));
  } finally {
    dangTaiBang.value = false;
  }
};

const tai = async () => {
  if (!khoang.value) return;
  const { from, to } = khoang.value;
  const ky = kyTruoc(from, to);
  moc.value = ky;
  dangTai.value = true;
  try {
    // Kỳ trước chạy song song: không ai phải chờ nó xong mới thấy số kỳ này.
    const [nay, cu, ds] = await Promise.all([
      goiNgay(from, to, 'ngay'),
      ky ? goiNgay(ky.tu, ky.den, 'ngay') : Promise.resolve(null),
      HieuSuatAPI.trang({
        since: from,
        until: to,
        inboxIds: selectedInboxIds.value,
      }).then(r => r.data.trang || []),
    ]);
    theoNgay.value = nay;
    theoNgayTruoc.value = cu;
    cacTrang.value = ds;
    // Số theo giờ của kỳ cũ không còn đúng sau khi đổi ngày hay đổi trang.
    theoGio.value = null;
    if (gom.value === 'gio') await taiGio();
  } catch {
    theoNgay.value = null;
    theoNgayTruoc.value = null;
    useAlert(t('BONBOZ.TRANG_TK.LOI_TAI'));
  } finally {
    dangTai.value = false;
  }
};

const doiGom = async kieu => {
  gom.value = kieu;
  if (kieu === 'gio') await taiGio();
};

const doiBoLoc = ({ from, to }) => {
  if (!from || !to) return;
  khoang.value = { from, to };
  // Đổi khoảng ngày thì tab trang quay về Tổng hợp — giữ tab cũ là giữ một
  // trang có thể đã ra khỏi phạm vi.
  trangCua.value = null;
  tai();
};

const chonTrang = id => {
  trangCua.value = id;
  tai();
};

// Lua chon trang nam trong `ui_settings` cua nguoi dung, tai ve SAU khi trang
// da mount — lan tai dau tien co the chay khi mang con rong (= tat ca).
watch(selectedInboxIds, () => {
  trangCua.value = null;
  tai();
});

// ------------------------------------------------------------------ biểu đồ
const dongNgay = computed(() => theoNgay.value?.ngay || []);
const nhanTruc = computed(() =>
  dongNgay.value.map(d => ngay(d.moc * 1000, 'ngayThang'))
);
const coSoLieu = computed(() =>
  dongNgay.value.some(d => d.tin_khach || d.binh_luan_khach)
);

// --------------------------------------------------------------- ô nổi bật
const tongNay = computed(() => theoNgay.value?.tong || null);
const tongTruoc = computed(() => theoNgayTruoc.value?.tong || null);

// Chênh lệch phần trăm. Trả `null` khi kỳ trước bằng 0: chia cho 0 ra Infinity,
// mà "tăng vô hạn" thì không phải một con số ai dùng được.
const lech = (a, b) => (b > 0 ? Math.round(((a - b) / b) * 1000) / 10 : null);

// Kỳ trước có 2 hội thoại, kỳ này 25 -> "+1150%". Con số đó đúng về số học
// nhưng không ai dùng được, và nó chiếm chỗ của những thay đổi thật sự đáng
// nhìn. Trên 300% thì nói thẳng "gấp N lần".
const chuLech = n => {
  const d = Math.abs(n);
  return d > 300
    ? t('BONBOZ.TRANG_TK.GAP_LAN', { n: Math.round(d / 100 + 1) })
    : `${d}%`;
};

// Bằng kỳ trước thì KHÔNG có mũi tên — "▲0%" là mũi tên đi lên dán vào một con
// số không đổi, đọc thành tăng.
const muiLech = n => {
  if (n > 0) return '▲';
  return n < 0 ? '▼' : '';
};
const mauLech = n => {
  if (n > 0) return 'text-n-teal-11';
  return n < 0 ? 'text-n-ruby-11' : 'text-n-slate-11';
};

const O_NOI_BAT = [
  { khoa: 'sdt_moi', icon: 'i-lucide-smartphone', bien: '--bonboz-tre' },
  { khoa: 'khach_cu_nhan', icon: 'i-lucide-megaphone', bien: '--bonboz-cho' },
  { khoa: 'khach_moi', icon: 'i-lucide-puzzle', bien: '--bonboz-nguoi' },
  { khoa: 'hoi_thoai', icon: 'i-lucide-messages-square', bien: '--bonboz-mo' },
];

const oNoiBat = computed(() =>
  O_NOI_BAT.map(o => ({
    ...o,
    so: tongNay.value?.[o.khoa] ?? 0,
    lech: lech(tongNay.value?.[o.khoa] ?? 0, tongTruoc.value?.[o.khoa] ?? 0),
  }))
);

// Nhãn của kỳ so sánh — luôn là NGÀY THẬT, không phải chữ "kỳ trước".
const nhanKyTruoc = computed(() =>
  moc.value
    ? t('BONBOZ.TRANG_TK.SO_KY_TRUOC', {
        tu: ngay(moc.value.tu * 1000, 'ngayThang'),
        den: ngay(moc.value.den * 1000, 'ngayThang'),
      })
    : t('BONBOZ.TRANG_TK.KHONG_CO_KY_TRUOC')
);

// ------------------------------------------------------------------- bảng
const nguonBang = computed(() =>
  gom.value === 'gio' ? theoGio.value : theoNgay.value
);
</script>

<template>
  <ReportHeader
    :header-title="$t('BONBOZ.TRANG_TK.TIEU_DE')"
    :header-description="$t('BONBOZ.TRANG_TK.MO_TA')"
  />

  <div class="flex flex-col w-full gap-4 mx-auto max-w-6xl">
    <OverviewReportFilters :disabled="dangTai" @filter-change="doiBoLoc" />

    <PhamVi />

    <!-- Hàng tab trang: tương đương bộ chọn trang ở thanh trên của Pancake.
         Chỉ hiện khi có từ hai trang trở lên — một trang thì không có gì để
         chuyển qua lại. -->
    <div
      v-if="cacTrang.length > 1"
      class="flex flex-wrap gap-1 p-1 rounded-lg bg-n-alpha-1 w-fit"
    >
      <button
        type="button"
        class="px-3 py-1.5 text-sm rounded-md transition-colors"
        :class="
          trangCua === null
            ? 'bg-n-solid-1 text-n-slate-12 font-medium shadow-sm'
            : 'text-n-slate-11 hover:text-n-slate-12'
        "
        @click="chonTrang(null)"
      >
        {{ $t('BONBOZ.TRANG_TK.TAB_TONG') }}
      </button>
      <button
        v-for="tr in cacTrang"
        :key="tr.id"
        type="button"
        class="px-3 py-1.5 text-sm rounded-md transition-colors"
        :class="
          trangCua === tr.id
            ? 'bg-n-solid-1 text-n-slate-12 font-medium shadow-sm'
            : 'text-n-slate-11 hover:text-n-slate-12'
        "
        @click="chonTrang(tr.id)"
      >
        {{ tr.ten }}
      </button>
    </div>

    <!-- ================= 1. TỔNG QUAN VỀ TRANG ================= -->
    <SectionCard
      :title="$t('BONBOZ.TRANG_TK.VE_TRANG')"
      :description="$t('BONBOZ.TRANG_TK.VE_TRANG_MO_TA')"
    >
      <div v-if="dangTai" class="rounded-lg h-60 bg-n-alpha-2 animate-pulse" />
      <p
        v-else-if="!coSoLieu"
        class="m-0 py-20 text-sm text-center text-n-slate-11"
      >
        {{ $t('BONBOZ.BIEU_DO.CHUA_CO') }}
      </p>
      <template v-else>
        <div class="h-60">
          <BieuDoTrang
            :nhan="nhanTruc"
            :binh-luan="dongNgay.map(d => d.binh_luan_khach)"
            :tin-nhan="dongNgay.map(d => d.tin_khach)"
            :ten-binh-luan="$t('BONBOZ.TRANG_TK.SO_BINH_LUAN')"
            :ten-tin-nhan="$t('BONBOZ.TRANG_TK.SO_TIN_NHAN')"
          />
        </div>
        <div
          class="flex flex-wrap justify-center gap-5 mt-3 text-xs text-n-slate-11"
        >
          <span class="flex items-center gap-1.5">
            <span
              class="rounded-full size-2.5 shrink-0 bg-[rgb(var(--bonboz-xong))]"
              aria-hidden="true"
            />
            {{ $t('BONBOZ.TRANG_TK.SO_BINH_LUAN') }}
          </span>
          <span class="flex items-center gap-1.5">
            <span
              class="rounded-full size-2.5 shrink-0 bg-[rgb(var(--bonboz-mo))]"
              aria-hidden="true"
            />
            {{ $t('BONBOZ.TRANG_TK.SO_TIN_NHAN') }}
          </span>
        </div>
      </template>
    </SectionCard>

    <!-- ================= 2. BỐN Ô NỔI BẬT ================= -->
    <!-- BonBoZ: mot cot duoi 640px. Hai cot tren man 360px ra o rong ~170px,
         con so va nhan deu bi be dong. -->
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <div
        v-for="o in oNoiBat"
        :key="o.khoa"
        class="flex items-center gap-3 p-4 border rounded-xl border-n-weak bg-n-solid-2"
      >
        <span
          class="grid rounded-lg size-12 shrink-0 place-items-center"
          :style="{ background: `rgb(var(${o.bien}) / 0.12)` }"
        >
          <span
            class="block size-6"
            :class="o.icon"
            :style="{ color: `rgb(var(${o.bien}))` }"
            aria-hidden="true"
          />
        </span>
        <span class="min-w-0">
          <span class="flex items-baseline gap-2">
            <span
              v-if="dangTai"
              class="block w-10 h-7 rounded bg-n-alpha-2 animate-pulse"
            />
            <span
              v-else
              class="text-2xl font-semibold tabular-nums text-n-slate-12"
            >
              {{ o.so.toLocaleString() }}
            </span>
            <span
              v-if="!dangTai && o.lech !== null"
              v-tooltip.top="nhanKyTruoc"
              class="text-xs whitespace-nowrap"
              :class="mauLech(o.lech)"
            >
              <span aria-hidden="true">{{ muiLech(o.lech) }}</span>
              {{ chuLech(o.lech) }}
            </span>
          </span>
          <span class="block mt-0.5 text-sm truncate text-n-slate-11">
            {{ $t(`BONBOZ.TRANG_TK.C_${o.khoa}`) }}
          </span>
        </span>
      </div>
    </div>

    <!-- ================= 3. THỐNG KÊ CHI TIẾT ================= -->
    <BangTheoNgay
      :dong="nguonBang?.ngay || []"
      :tong="nguonBang?.tong || null"
      :gom="gom"
      :dang-tai="dangTai || dangTaiBang"
      @doi-gom="doiGom"
    />
  </div>
</template>
